import { Fragment, useCallback, useState } from 'react';
import call from '~/assets/icons/call.svg';
import carDoc from '~/assets/icons/car_doc.svg';
import heart from '~/assets/icons/heart.svg';
import info from '~/assets/icons/info.svg';
import message from '~/assets/icons/message.svg';
import quote from '~/assets/icons/quote.svg';
import { CollectionImage, CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import {
	NumberplatePreview,
	NumberPlatePreviewSize,
} from '~/components/ui/NumberplatePreview';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks/useWalletIcon';
import {
	Currency,
	ModalButtonColor,
	ModalType,
	VehicleNumberPlateType,
	WalletType,
} from '~/shared';
import photoExample from '../../assets/images/photo_example.jpg';
import { useModal } from '../../hooks';
import { setReportVisible, useLayoutDispatch } from '../../redux';
import {
	AppAdsPlayerAvatar,
	AppAdsPlayerAvatarSize,
} from '../AppAdsPlayerAvatar';
import {
	StyledAboutTitle,
	StyledBottomContainer,
	StyledButton,
	StyledButtonContainer,
	StyledButtonContent,
	StyledCenterButtons,
	StyledDescriptionContainer,
	StyledDivider,
	StyledInfoHint,
	StyledInfoHintContainer,
	StyledMainContainer,
	StyledPhotoContainer,
	StyledPhotoThumb,
	StyledPhotoThumbsContainer,
	StyledStatsContainer,
	StyledTableContainer,
} from './AppAdsItemPageVehicleHouse.styled';

const AppAdsItemPageVehicleHouse = () => {
	const dispatch = useLayoutDispatch();
	const [activePhotoIndex, setActivePhotoIndex] = useState(0);
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const isOwner = false;
	const { showModal } = useModal();

	const handleBuyReport = useCallback(() => {
		showModal(
			{
				type: ModalType.Price,
				title: 'Подтверждение',
				text: 'Вы действительно хотите купить отчёт на транспорт BMW M2 G87?',
				price: 50000,
				wallet: WalletType.Cash,
				acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
				cancelButton: { text: 'Отменить', color: ModalButtonColor.Secondary },
			},
			(result) => {
				if (!result.isAccepted) {
					return;
				}

				// @TODO: покупка отчета
				dispatch(setReportVisible(true));
			},
		);
	}, []);

	const handleBuy = useCallback(() => {
		showModal(
			{
				type: ModalType.Price,
				title: 'Подтверждение',
				text: 'Вы действительно хотите автомобиль BMW M2 G87?',
				price: 50000,
				wallet: WalletType.Cash,
				acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
				cancelButton: { text: 'Отменить', color: ModalButtonColor.Secondary },
			},
			(result) => {
				if (!result.isAccepted) {
					return;
				}

				// @TODO: покупка автомобиля
				console.log('ads: Buy vehicle');
			},
		);
	}, []);

	const handleDelete = useCallback(() => {
		showModal(
			{
				type: ModalType.Price,
				title: 'Подтверждение',
				text: 'Вы действительно хотите удалить объявление?',
				price: 50000,
				wallet: WalletType.Cash,
				acceptButton: { text: 'Удалить', color: ModalButtonColor.Danger },
				cancelButton: { text: 'Отменить', color: ModalButtonColor.Secondary },
			},
			(result) => {
				if (!result.isAccepted) {
					return;
				}

				// @TODO: покупка автомобиля
				console.log('ads: Delete');
			},
		);
	}, []);

	return (
		<StyledMainContainer>
			<div>
				<StyledPhotoContainer>
					<CollectionImage collection={'vehicles'} id={'a80'} size={156} />
					<StyledInfoHintContainer $position={'left'}>
						<StyledInfoHint>
							<Text>11:22</Text>
						</StyledInfoHint>
					</StyledInfoHintContainer>
					<StyledInfoHintContainer $position={'right'}>
						<NumberplatePreview
							numberPlate={{
								type: VehicleNumberPlateType.Classic,
								text: 'A111AA',
								region: '38',
							}}
							size={NumberPlatePreviewSize.Size20}
						/>
					</StyledInfoHintContainer>
				</StyledPhotoContainer>
				<StyledPhotoThumbsContainer>
					<StyledPhotoThumb
						$stock
						$active={activePhotoIndex === 0}
						onClick={() => setActivePhotoIndex(0)}
						$type={'car'}
					>
						<CollectionImage collection={'vehicles'} id={'a80'} size={46} />
					</StyledPhotoThumb>
					<StyledPhotoThumb
						$active={activePhotoIndex === 1}
						onClick={() => setActivePhotoIndex(1)}
					>
						<img src={photoExample} />
					</StyledPhotoThumb>
					<StyledPhotoThumb
						$active={activePhotoIndex === 2}
						onClick={() => setActivePhotoIndex(2)}
					>
						<img src={photoExample} />
					</StyledPhotoThumb>
				</StyledPhotoThumbsContainer>
				<StyledDescriptionContainer>
					<div className={'title'}>
						<img src={quote} />
						<Text>Описание</Text>
					</div>
					<Text>
						Продаю свою родную ласточку, в идеальном состоянии, полностью
						подготовленная для эксплуатации на дорогах общего пользования так
						сказать. Возможен торг у капота! Перекупы идут лесом, вместе с
						Автосалонами!
					</Text>
				</StyledDescriptionContainer>
				<StyledStatsContainer>
					<Text>14.02.24</Text>
					<Text>5 288 просмотров</Text>
				</StyledStatsContainer>
			</div>
			<StyledDivider />
			<div>
				<StyledButtonContainer>
					<AppAdsPlayerAvatar
						nickName="Jevico"
						size={AppAdsPlayerAvatarSize.Medium}
					/>
					{isOwner && (
						<Text
							style={{
								fontSize: 14,
								fontWeight: 500,
								color: '#ffffff',
								opacity: 0.5,
								marginLeft: 10,
							}}
						>
							Vladislav
							<br />
							Syrovackiy
						</Text>
					)}
					{!isOwner && (
						<StyledCenterButtons>
							<StyledButton $color={'#1F8034'}>
								<img src={call} />
								<Text>Позвонить игроку</Text>
							</StyledButton>
							<StyledButton $color={'#2D70DA'}>
								<img src={message} />
								<Text>Написать игроку</Text>
							</StyledButton>
						</StyledCenterButtons>
					)}
					<StyledButton
						$color={'#C71E1E'}
						style={{ marginLeft: 'auto', minWidth: 40 }}
					>
						<img src={heart} />
					</StyledButton>
				</StyledButtonContainer>
				<StyledAboutTitle>
					<img src={info} />
					<Text>О товаре</Text>
				</StyledAboutTitle>
				<StyledTableContainer>
					<Text>Продавец</Text>
					<Text>Jevico</Text>
					<Text>Тип товара</Text>
					<Text>Транспорт</Text>
					<Text>Название</Text>
					<Text>BMW M2 G87</Text>
					<Text>Пробег</Text>
					<Text>250 000 км.</Text>
					<Text>Кол-во владельцев</Text>
					<Text>6 чел.</Text>
					<Text>Тип краски</Text>
					<Text>Перламутровая</Text>
					<Text>Кузов</Text>
					<Text>24040*********</Text>
					<Text>Состояние</Text>
					<Text className={'buy'} onClick={handleBuyReport}>
						Купить автотеку
					</Text>
				</StyledTableContainer>
				<StyledBottomContainer>
					<Button
						color={ButtonColors.Default}
						height={ButtonHeight.Height50}
						style={{ fontSize: 16, gridColumn: 'span 2' }}
					>
						<StyledButtonContent onClick={handleBuyReport}>
							<img src={carDoc} width={14} height={14} />
							<Text>Посмотреть отчёт об авто</Text>
						</StyledButtonContent>
					</Button>

					{isOwner ? (
						<Fragment>
							<Button
								color={ButtonColors.Select}
								height={ButtonHeight.Height50}
								style={{ fontSize: 16 }}
							>
								<Text>Изменить стоимость</Text>
							</Button>
							<Button
								color={ButtonColors.Cancel}
								height={ButtonHeight.Height50}
								style={{ fontSize: 16 }}
								onClick={handleDelete}
							>
								<Text>Удалить объявление</Text>
							</Button>
						</Fragment>
					) : (
						<Fragment>
							<Button
								color={ButtonColors.Select}
								height={ButtonHeight.Height50}
								style={{ fontSize: 16 }}
							>
								<Text>Тест - драйв</Text>
							</Button>
							<Button
								color={ButtonColors.Buy}
								height={ButtonHeight.Height50}
								style={{ fontSize: 16 }}
								onClick={handleBuy}
							>
								<StyledButtonContent>
									<Text>Купить за</Text>
									<CurrencyIcon icon={rubleIcon} size="sm" />
									<Text>50 000</Text>
								</StyledButtonContent>
							</Button>
						</Fragment>
					)}
				</StyledBottomContainer>
			</div>
		</StyledMainContainer>
	);
};

export { AppAdsItemPageVehicleHouse };
